// extracted by mini-css-extract-plugin
export default {"icon":"AppIcon_icon__SQYmd"};